export const urls ={
    apiBaseUrl: process.env.REACT_APP_API_URL
}
